import React, { useEffect, useRef, useState } from "react";
import Images from "../../assets/Image";
// import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";
import { useForm } from "react-hook-form";
import { SOCIAL_LINKS } from "../../utils/constants";
const ContactUsComp = () => {
  const {
    formState: { errors },
    register,
  } = useForm();
  const form = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [showIcons, setShowIcons] = useState(false);

  useEffect(() => {
    // For the address block
    const addressElements = document.querySelectorAll(
      ".contactEnquiryAddressBlock",
    );
    const addressObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible-address");
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    addressElements.forEach((el) => addressObserver.observe(el));

    // For the form fields
    const inputFields = document.querySelectorAll(".enquiryFormInputField");
    const formObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("visible-form");
            }, index * 300); // stagger the animation for each field
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    inputFields.forEach((input) => formObserver.observe(input));

    return () => {
      addressObserver.disconnect();
      formObserver.disconnect();
    };
  }, []);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_520oyz9", "template_xr5ts3y", form.current, {
        publicKey: "YI1Dlv7k1QHWv_o9e",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("form submitted successfully..");
        },
        (error) => {
          console.log("FAILED...", error.text);
        },
      );
  };
  return (
    <>
      <div className="contactus_heading_block">
        <div className="contactus_left_block">
          <div className="contactus_heading_container">
            <h6 className="contact_us_heading my-3">Contact Us</h6>
            <p className="contact_us_sub_heading">
              We appreciate your Interest with us,
              <br />
              Don't hesitate to reach us
            </p>
          </div>
        </div>
        <div className="contactus_right_block">
          <div className="contactus_image_block">
            <img
              src={Images?.shareImage}
              alt="no-image"
              className="contactus_image"
            />
          </div>
        </div>
      </div>
      <div className="contact_us_sub_heading_block">
        <h5 className="contact_us_sub_title">Contact Us</h5>
        <p className="event_content_para">
          Whether you have a question about our products, pricing, need a
          design, or anything else, our team is
          <br /> ready to answer all your questions
        </p>
      </div>

      {/* CONTACT CARD SECTION */}
      <div className="contact_card_section">
        <div className="contact_card_block">
          <div className="contact_card">
            <div className="card_img_block">
              <div className="card-image">
                <img
                  src={Images?.addressIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
            <h5 className="card_address_title">Address</h5>
            <p className="contact_card_address">
              Old No. 15/1, New No. 37,Dr.Muthulakshmi Salai,Lattice Bridge
              Road, Adyar,Chennai 600 020, INDIA.
            </p>
          </div>
          <div className="contact_card">
            <div className="card_img_block">
              <div className="card-image">
                <img
                  src={Images?.phoneIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
            <h5 className="card_address_title">Contact Number</h5>
            <p className="contact_card_address">
              <u>+91 97909 34910</u>
            </p>
          </div>
          <div className="contact_card">
            <div className="card_img_block">
              <div className="card-image">
                <img
                  src={Images?.teleIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
            <h5 className="card_address_title">Email Address</h5>
            <p className="contact_card_address">enquiries@usppkg.com</p>
          </div>
          <div className="contact_card">
            <div className="card_img_block">
              <div className="card-image">
                <img
                  src={Images?.followIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
            <h5 className="card_address_title">Follow Us</h5>
            <div className="contactus-image-block">
              {/* <div className="usp_image_block">
                <img
                  src={Images?.instagramIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <div className="usp_image_block">
                <img
                  src={Images?.facebookIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%" }}
                />
              </div> */}
              <a
                className="usp_image_block"
                href={SOCIAL_LINKS.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images?.linkedin}
                  alt="no-image"
                  style={{ width: "100%", height: "100%" }}
                />
              </a>
              <a
                className="usp_image_block"
                href={SOCIAL_LINKS.youtube}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={Images?.youtueIcon}
                  alt="no-image"
                  style={{ width: "100%", height: "100%" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT ENQUIRY */}

      <div className="contactUs_Main_Section">
        <div className="contactusEnquirySection">
          <div className="contactUsEnquiryAddressBlock">
            <h6 className="enquiry_address_heading">Contact us</h6>
            <p className="--contact-address">
              Have a question or interested in learning more about us and our
              products? Please contact us using the "Get in Touch" form below or
              by emailing <u style={{ color: "#3185D2" }}>enquiries@usppkg.com</u>
              / by calling  <u style={{ color: "#3185D2" }}>+91 9790934910</u>.
            </p>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.locationIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">
                Old No. 15/1, New No. 37, Dr.Muthulakshmi Salai, <br />
                Lattice Bridge Road, Adyar, Chennai 600020, India.
              </p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.phoneCall}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">+91 9790934910</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.meaageIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">enquiries@usppkg.com</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.clockIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">
                Mon-Fri 9.30 am to 6.00 pm
                <br />
                Sat 9.30 am to 1.00 pm
              </p>
            </div>
          </div>
          <div className="contactUsEnquiryFormBlock">
            <h5 className="contactUsEnquiryFormHeading">Get In Touch</h5>
            <form ref={form} onSubmit={sendEmail}>
              <div>
                <input
                  type="text"
                  name="from_name"
                  className="enquiryFormInputField"
                  placeholder="Name"
                  required
                />
              </div>
              <div>
                <input
                  type="email"
                  name="from_email"
                  className="enquiryFormInputField"
                  placeholder="Email Id"
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="mobileNumber"
                  className="enquiryFormInputField"
                  placeholder="Mobile Number"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="need"
                  className="enquiryFormInputField"
                  placeholder="Need"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="message"
                  className="enquiryFormInputField"
                  placeholder="What is your need"
                  required
                />
              </div>
              <div className="contactus_btn_block">
                <button className="contactUsSubmitBtn">Submit Now</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Floating share - intentionally removed nested JSX comments to avoid
          syntax errors. If needed, re-add a cleaned version of this block. */}
    </>
  );
};

export default ContactUsComp;
